import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

type SFBackspaceIconProps = Omit<SvgIconProps, "color"> & {
  color?: string;
};

/**
 * @param param0
 * @returns
 * @note 피그마에서 사이즈가 정사각형이 아닌 이슈로 `SvgIcon` 컴포넌트는 사용하지 않음.
 */
export default function SFBackspaceIcon({
  color,
  ...props
}: SFBackspaceIconProps) {
  return (
    // <SvgIcon {...props}>
    <svg
      width="29"
      height="20"
      viewBox="0 0 29 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.40523 1.65103L2.19957 8.44371C1.51553 9.19246 1.5002 10.3347 2.1639 11.1015L8.40181 18.3089C8.78171 18.7478 9.33357 19 9.91407 19H26C27.1046 19 28 18.1046 28 17V3C28 1.89543 27.1046 1 26 1H9.88181C9.32003 1 8.78415 1.23627 8.40523 1.65103Z"
        stroke="#555555"
        strokeWidth="2"
      />
      <path
        d="M14 7L17 10M17 10L20 7M17 10L14 13M17 10L20 13"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // </SvgIcon>
  );
}
